module.exports = __webpack_public_path__ + "static/img/W_SLG.b2ddd15.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/W_SLG.jpg
// module id = 7Hau
// module chunks = 1